import { useState } from 'react'

const TOAST_DURATION_MS = 4500

// Generate -> preview -> download flow for the finished PDF. The heavy
// pdfGenerator module (pdf-lib) is imported on demand so it stays out of the
// initial bundle. Failures are reported through onError with a message ready
// to show. onDownloaded({ keepData }) runs right after the file was handed to
// the browser; the caller wipes the personal data unless the user ticked
// "keep my data" in the preview (the default is to wipe).
export const usePdfExport = ({
	formData,
	files,
	signatureData,
	customDocs,
	onError,
	onDownloaded,
	fallbackError,
}) => {
	const [isDownloading, setIsDownloading] = useState(false)
	const [previewPdfBytes, setPreviewPdfBytes] = useState(null)
	const [showToast, setShowToast] = useState(false)

	const generate = async () => {
		if (isDownloading) return
		setIsDownloading(true)
		try {
			const { generatePDF } = await import('../utils/pdfGenerator')
			const result = await generatePDF(formData, files, signatureData, customDocs)
			if (result.success) setPreviewPdfBytes(result.pdfBytes)
			else onError(result.message || fallbackError)
		} catch (error) {
			console.error('PDF generation failed', error)
			onError(fallbackError)
		} finally {
			setIsDownloading(false)
		}
	}

	const download = async ({ keepData = false } = {}) => {
		const { downloadPdfBytes } = await import('../utils/pdfGenerator')
		downloadPdfBytes(previewPdfBytes)
		setPreviewPdfBytes(null)
		setShowToast(true)
		setTimeout(() => setShowToast(false), TOAST_DURATION_MS)
		onDownloaded({ keepData })
	}

	const closePreview = () => setPreviewPdfBytes(null)

	return { isDownloading, previewPdfBytes, showToast, generate, download, closePreview }
}
